import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import PropTypes from 'prop-types';
// import {MdClose} from 'react-icons/md'

const ModalWrapper = ({ open = false, setOpen = null, children, title }) => {


    const cancelButtonRef = useRef(null)


    return (
        <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="fixed z-30 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <div className=" inline-block align-bottom rounded-md text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle ">
                                <div className="bg-white w-full relative ">
                                    {/* <MdClose 
                                    onClick={() => setIsOpen(false)}
                                    className=" cursor-pointertext-gray-500 text-2xl rounded-full absolute top-4 right-4 hover:bg-gray-50 hover:text-gray-800 hover:scale-125"/>
                                     */}
                                    <div className="mt-3 text-center sm:mt-0  sm:text-left">
                                        {
                                            title &&
                                            <Dialog.Title as="h3" className="capitalize text-lg leading-6 font-bold text-gray-800 px-4 py-4  border-b">
                                                {title}
                                            </Dialog.Title>
                                        }

                                        <div className="p-4 pb-8">
                                            {children}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>
    );
}

ModalWrapper.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
};

export default ModalWrapper;